<template>
  <div>
    <PageAllow controller="FinanceBills" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("financeBillDetail.title") }}
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="exportDetail()"
                >
                  <v-icon x-small class="pe-1">fa-file-export</v-icon>
                  {{ $t("financeBillDetail.export") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />

          <v-expansion-panel-content>
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text" v-if="bill.bill_obj_type == 1">
                    {{ $t("financeBillDetail.Fields.importers") }}{{ $t("Global.colon") }}
                  </span>
                  <span class="secondary--text" v-if="bill.bill_obj_type == 2">
                    {{ $t("financeBillDetail.Fields.supplier") }}{{ $t("Global.colon") }}
                  </span>
                  <span class="secondary--text" v-if="bill.bill_obj_type == 3">
                    {{ $t("financeBillDetail.Fields.stock") }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="bill.bill_obj_type == 1">
                    {{
                      finance_bill.shop.shop_name +
                      "(" +
                      finance_bill.shop.shop_code +
                      ")"
                    }}
                  </span>
                  <span v-if="bill.bill_obj_type == 2">
                    {{
                      finance_bill.supplier.supplier_name +
                      "(" +
                      finance_bill.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                  <span v-if="bill.bill_obj_type == 3">
                    {{
                      finance_bill.stock.name +
                      "(" +
                      finance_bill.stock.code +
                      ")"
                    }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("financeBillDetail.Fields.tel_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="bill.bill_obj_type == 1">
                    {{
                      finance_bill.shop.shop_user.name
                        ? finance_bill.shop.shop_user.name
                        : ""
                    }}
                  </span>
                  <span v-if="bill.bill_obj_type == 2">
                    {{
                      finance_bill.supplier.manager_name
                        ? finance_bill.supplier.manager_name
                        : ""
                    }}
                  </span>
                  <span v-if="bill.bill_obj_type == 3">
                    {{
                      finance_bill.stock.manager
                        ? finance_bill.stock.manager
                        : ""
                    }}
                  </span>
                  <span v-else> </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("financeBillDetail.Fields.tel_number")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="bill.bill_obj_type == 1">
                    {{
                      finance_bill.shop.shop_user.tel
                        ? finance_bill.shop.shop_user.tel
                        : ""
                    }}
                  </span>
                  <span v-if="bill.bill_obj_type == 2">
                    {{
                      finance_bill.supplier.manager_tel
                        ? finance_bill.supplier.manager_tel
                        : ""
                    }}
                  </span>
                  <span v-if="bill.bill_obj_type == 3">
                    {{
                      finance_bill.stock.tel
                        ? finance_bill.stock.tel
                        : ""
                    }}
                  </span>
                  <span v-else> </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("financeBillDetail.Fields.created")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ finance_bill.created | formatTime }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- 活动记录 -->
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("financeBillDetail.activities.title") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="activities_details"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span>
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- 对账单明细 -->
      <v-expansion-panels v-model="Detail" multiple accordion class="mt-4">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("financeBillDetail.Fields.detail") }}
              <v-spacer />
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />
          <v-expansion-panel-content>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="6" md="4" class="text-no-wrap">
                  <span class="font-weight-bold me-2"
                    >{{ $t("financeBillDetail.obj")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span v-if="bill.bill_obj_type == 1">
                    {{
                      finance_bill.shop.shop_name +
                      "(" +
                      finance_bill.shop.shop_code +
                      ")"
                    }}
                  </span>
                  <span v-if="bill.bill_obj_type == 2">
                    {{
                      finance_bill.supplier.supplier_name +
                      "(" +
                      finance_bill.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                  <span v-if="bill.bill_obj_type == 3">
                    {{
                      finance_bill.stock.name +
                      "(" +
                      finance_bill.stock.code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 1">
                  <span
                    class="font-weight-bold me-2"
                    v-if="finance_bill.finance_bill_type == 101"
                  >
                    {{ $t("financeBillDetail.org_code") }}{{ $t("Global.colon") }}
                  </span>
                  <span
                    class="font-weight-bold me-2"
                    v-else-if="finance_bill.finance_bill_type == 102"
                  >
                    {{ $t("financeBillDetail.return_order_code") }}{{ $t("Global.colon") }}
                  </span>
                  <a
                    v-if="finance_bill.finance_bill_type == 101"
                    style="text-decoration: none"
                    :href="'/#/orders/' + bill.org_id"
                  >
                    {{ bill.org_code }}
                  </a>
                  <a
                    v-if="finance_bill.finance_bill_type == 102"
                    style="text-decoration: none"
                    :href="'/#/return-orders/' + bill.org_id"
                  >
                    {{ bill.org_code }}
                  </a>
                  <v-chip
                    v-if="bill.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 2">
                  <span
                    class="font-weight-bold me-2"
                    v-if="finance_bill.finance_bill_type == 201"
                  >
                    {{ $t("financeBillDetail.purchase_bill_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span
                    class="font-weight-bold me-2"
                    v-else-if="finance_bill.finance_bill_type == 202"
                  >
                    {{ $t("financeBillDetail.return_purchase_bill_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span
                      class="font-weight-bold me-2"
                      v-else-if="finance_bill.finance_bill_type == 203"
                  >
                    {{ $t("financeBillDetail.return_purchase_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <a
                    style="text-decoration: none"
                    :href="'/#/receipts/' + bill.id + '?time_type=1'"
                  >
                    {{ bill.bill_code }}
                  </a>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 2">
                  <span
                    class="font-weight-bold me-2"
                    v-if="finance_bill.finance_bill_type == 201"
                  >
                    {{ $t("financeBillDetail.in_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span
                    class="font-weight-bold me-2"
                    v-else-if="finance_bill.finance_bill_type == 202"
                  >
                    {{ $t("financeBillDetail.out_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span
                      class="font-weight-bold me-2"
                      v-else-if="finance_bill.finance_bill_type == 203"
                  >
                    {{ $t("financeBillDetail.return_purchase_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <a
                    v-if="finance_bill.finance_bill_type == 201"
                    style="text-decoration: none"
                    :href="'/#/stock-orders-in/' + bill.org_id"
                  >
                    {{ bill.org_code }}
                  </a>
                  <a
                    v-if="finance_bill.finance_bill_type == 202"
                    style="text-decoration: none"
                    :href="'/#/stock-orders-out/' + bill.org_id"
                  >
                    {{ bill.org_code }}
                  </a>
                  <a
                      v-if="finance_bill.finance_bill_type == 203"
                      style="text-decoration: none"
                      :href="'/#/return-purchases/' + bill.org_id"
                  >
                    {{ bill.org_code }}
                  </a>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 1">
                  <span class="font-weight-bold me-2">
                    {{ $t("financeBillDetail.sum_price") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}{{ finance_bill.fee | formatMoney }}
                  </span>
                  <span class="red--text">
                    (
                    {{
                      $t("financeBillDetail.fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}</span
                  >
                  <span class="red--text"
                    >{{ fee | formatMoney }}
                    )
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 2">
                  <span class="font-weight-bold me-2">
                    {{ $t("financeBillDetail.sum_price_tax") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span
                    >{{ $t("Global.money")
                    }}{{ finance_bill.total_price | formatMoney }}</span
                  >
                  <span class="red--text">
                    (
                    {{
                      $t("financeBillDetail.fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}</span
                  >
                  <span class="red--text"
                    >{{ finance_bill.fee | formatMoney }} )
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 3">
                  <span class="font-weight-bold me-2" v-if="finance_bill.finance_bill_type == 301">
                    {{ $t("financeBillDetail.requisitions_bill_code")}}{{ $t("Global.colon") }}
                  </span>
                  <span class="font-weight-bold me-2" v-if="finance_bill.finance_bill_type == 302">
                    {{ $t("financeBillDetail.requisitions_pay_bill_code")}}{{ $t("Global.colon") }}
                  </span>
                  <a
                    style="text-decoration: none"
                    :href="'/#/receipts/' + bill.id + '?time_type=1'"
                  >
                    {{ bill.bill_code }}
                  </a>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 3">
                  <span class="font-weight-bold me-2">
                    {{ $t("financeBillDetail.requisitions_code") }}{{ $t("Global.colon") }}
                  </span>
                  <a
                    style="text-decoration: none"
                    :href="'/#/requisitions/' + bill.org_id"
                  >
                    {{ bill.org_code }}
                  </a>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 3">
                  <span class="font-weight-bold me-2">
                    {{ $t("financeBillDetail.sum_price_tax") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money")}}{{ finance_bill.total_price | formatMoney }}
                  </span>
                  <span class="red--text">
                    (
                    {{
                      $t("financeBillDetail.fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}
                  </span>
                  <span class="red--text">
                    {{ finance_bill.fee | formatMoney }} )
                  </span>
                </v-col>
              </v-row>
              <v-row dense class="px-1" v-if="bill.bill_obj_type == 1">
                <v-spacer />
                <v-col cols="12" sm="12" md="4">
                  <span class="transparent--text font-weight-bold me-2">
                    {{ $t("financeBillDetail.sum_price") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span class="transparent--text"
                    >{{ $t("Global.money")
                    }}{{ finance_bill.fee | formatMoney }}</span
                  >
                  <span class="red--text">
                    (
                    {{
                      $t("ReceiptDetail.service_charge") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}</span
                  >
                  <span class="red--text">
                    {{ bill.service_charge | formatMoney }})
                  </span>
                </v-col>
              </v-row>
              <v-row dense class="px-1" v-if="bill.bill_obj_type == 1">
                <v-spacer />
                <v-col cols="12" sm="12" md="4">
                  <span class="transparent--text font-weight-bold me-2">
                    {{ $t("financeBillDetail.sum_price") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span class="transparent--text"
                    >{{ $t("Global.money")
                    }}{{ finance_bill.fee | formatMoney }}</span
                  >
                  <span class="red--text">
                    (
                    {{
                      $t("ReceiptDetail.logistics_fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}</span
                  >
                  <span class="red--text">
                    {{ finance_bill.logistics_fee | formatMoney }})
                  </span>
                </v-col>
              </v-row>
              <v-row
                dense
                class="px-1"
                v-if="
                  finance_bill.finance_bill_type == 101 &&
                  settings &&
                  settings.order_discount
                "
              >
                <v-spacer />
                <v-col cols="12" sm="12" md="4">
                  <span class="transparent--text font-weight-bold me-2">
                    {{ $t("financeBillDetail.sum_price") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span class="transparent--text"
                    >{{ $t("Global.money")
                    }}{{ finance_bill.fee | formatMoney }}</span
                  >
                  <span class="red--text">
                    (
                    {{
                      $t("ReceiptDetail.order_discount") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}</span
                  >
                  <span class="red--text">
                    {{ finance_bill.order_discount | formatMoney }})
                  </span>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              :headers="receiptHeaders"
              :items="bill_details"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.material.material_name="{ item }">
                <span>{{ item.material.material_name }}</span>
                <br />
                <span class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
                  <span
                    v-if="
                      item.material &&
                      item.material.standard_name &&
                      item.material.standard_name.length > 12
                    "
                    :title="item.material.standard_name"
                    style="cursor: pointer"
                  >
                    {{ item.material.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.material.standard_name }}
                  </span>
                </span>
              </template>
              <template v-slot:item.price="{ item }">
                <span>
                  {{ $t("Global.money") }}{{ item.price | formatMoney }}
                </span>
              </template>
              <template v-slot:item.total="{ item }">
                <span>
                  {{ $t("Global.money") }}{{ item.total | formatMoneyFloor }}
                </span>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import FinanceBills from "@/api/finance_bills";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.inanceReceipt"),
          disabled: true,
          href: "/finance-receipt",
        },
      ];
      if (this.$route.path.startsWith("/finance-bills-order")) {
        items.push({
          text: i18n.t("Nav.financeBillForOrder"),
          disabled: true,
          href: "/finance-bills-order",
        });
      } else if(this.$route.path.startsWith("/finance-bills-returnPurchase")) {
        items.push({
          text: i18n.t("Nav.financeBillForReturnPurchase"),
          disabled: true,
          href: "/finance-bills-purchase",
        })
      } else if (this.$route.path.startsWith("/finance-bills-return")) {
        items.push({
          text: i18n.t("Nav.financeBillForReturn"),
          disabled: true,
          href: "/finance-bills-return",
        });
      } else if (this.$route.path.startsWith("/finance-bills-purchaseReturn")) {
        items.push({
          text: i18n.t("Nav.financeBillForPurchaseReturn"),
          disabled: true,
          href: "/finance-bills-purchaseReturn",
        });
      } else if (this.$route.path.startsWith("/finance-bills-purchase")) {
        items.push({
          text: i18n.t("Nav.financeBillForPurchase"),
          disabled: true,
          href: "/finance-bills-purchase",
        });
      }
      items.push({
        text: i18n.t("Nav.financeBillDetail"),
        disabled: true,
      });
      items.push({
        text:
          this.finance_bill && this.finance_bill.finance_bill_code
            ? this.finance_bill.finance_bill_code
            : "",
        disabled: false,
        accent: true,
      });
      return items;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("financeBillDetail.activities.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("financeBillDetail.activities.Fields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("financeBillDetail.activities.Fields.operater_name"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    receiptHeaders() {
      return [
        {
          text: i18n.t("financeBillDetail.Fields.material_category"),
          align: "start",
          sortable: false,
          value: "material.material_category.name",
        },
        {
          text: i18n.t("financeBillDetail.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("financeBillDetail.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material.material_name",
        },
        {
          text: i18n.t("financeBillDetail.Fields.price"),
          align: "start",
          sortable: false,
          value: "price",
        },
        {
          text: i18n.t("financeBillDetail.Fields.num"),
          align: "start",
          sortable: false,
          value: "num",
        },
        {
          text: i18n.t("financeBillDetail.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("financeBillDetail.Fields.sum"),
          align: "start",
          sortable: false,
          value: "total",
        },
        {
          text: i18n.t("financeBillDetail.Fields.memo"),
          align: "start",
          sortable: false,
          value: "memo",
        },
      ];
    },

    ...mapState(["settings"]),
  },
  data: () => ({
    panels: [0],
    panelsDetail: [0],
    Detail: [0],
    tab: null,
    order_activities: [],
    bill_records: [],
    bill_details: [],
    activities_details: [],
    search: "",
    fee: 0,
    bill: {},
    finance_bill: {},
  }),

  mounted() {
    this.getFinanceBillsFromAPI();
  },

  methods: {
    getFinanceBillsFromAPI() {
      FinanceBills.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.finance_bill = response.data.finance_bill;
            this.bill = response.data.finance_bill.bill;
            this.fee = 0;
            this.bill_details =
              response.data.finance_bill.finance_bill_details.map((detail) => {
                this.fee += Number(detail.total);
                if (detail.total <= 0 && detail.price > 0 && detail.num > 0) {
                  detail.total = parseFloat(detail.price * detail.num).toFixed(
                    2
                  );
                }
                return detail;
              });
            this.activities_details = response.data.order_activities;
          }
        }.bind(this)
      );
    },
    exportDetail() {
      FinanceBills.exportDetail(this.$route.params.id);
    },
  },
};
</script>

<style>
</style>